import React, { Component } from 'react';
//import { message } from 'antd';
import { observer } from 'mobx-react';
import { DataStore } from './DataStore';
import CoverLyrics from './components/CoverLyrics';
import SongList from './components/SongList';
import ControlBar from './components/ControlBar';
import SearchBar from './components/SearchBar';
import PlayList from './components/PlayList';
import dialog from 'light-dialog';

import './App.css';

@observer
class App extends Component {
  onWindowResize = (event) => {
    DataStore.windowWidth = window.innerWidth;
    DataStore.windowHeight = window.innerHeight;
  }

  componentDidMount() {
    window.addEventListener('resize', this.onWindowResize);
    this.onWindowResize();
    //DataStore.errMassge = '测试报错！';
    //console.log(DataStore.errMassge)
  }

  componentDidUpdate() {
    //console.log(DataStore.errMassge);
    if(DataStore.errMassge) {
      dialog.piece(DataStore.errMassge, 3000);
      DataStore.errMassge = '';
    }
    //DataStore.errMassge = '测试报错！';
    // setInterval(() => {
    //   DataStore.errMassge = '测试报错！';
    //   console.log(DataStore.errMassge)
    // },2000);
  }

  componentWillUnmount() {
      window.removeEventListener('resize', this.onWindowResize)
  }

  render() {
    return (
      <div className="App" err={DataStore.errMassge}>
        <div className="bg-image-mask"></div>
        <div className="bg-image blur" 
          style={{backgroundImage:'url('+ DataStore.coutSongMassge.Img +')'}}></div>
        <div className="content flex">
          <div className="main">
            <CoverLyrics />
            <div className={"song-list-box flex" + (DataStore.showPlayList ? '' : ' full')}>
              <SearchBar />
              <SongList />
            </div>
            <PlayList />
          </div>
          <ControlBar />
        </div>
      </div>
    );
  }
}

export default App;


// WEBPACK FOOTER //
// ./src/App.js